// @ts-ignore
window.global ||= window;

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import './styles/index.scss';
import App from './components/App';
import './translations/i18n';
import { CookiesProvider } from 'react-cookie';
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configure } from 'mobx';
import { nanoid } from 'nanoid';
import { getTempMetricsId } from './utils/metrics-id';

// configure({ disableErrorBoundaries: true });

import './store/auth-store'; // this store has a global logout listener, so we instantiate it here.
if (import.meta.env.MODE !== 'production') {
  import('./styles/_dev-only.scss');
}

Sentry.init({
  dsn: "https://07636a4187cd4691b4516240b395d918@o986181.ingest.sentry.io/5942771",
  environment: import.meta.env.MODE,
  integrations: [
  ],
  ignoreErrors: [
    "Max connect time reached", // Don't care so much about this, it's a Dolby.io connection issue.
    "PiingConnectionError" // this happens when people have client open but we take stack down! So fires ALL THE TIME at present.
  ]
});

Sentry.setUser({ id: getTempMetricsId() });

const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  // <React.StrictMode>
  <CookiesProvider>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </CookiesProvider>,
  // </React.StrictMode>,
);